import {smsService} from "../services/smsService";

const state = {
  smsBalance: null,
}

const getters = {
  smsBalance: (state) => state.smsBalance,
}

const mutations = {
  setSmsBalance(state, smsBalance) {
    state.smsBalance = smsBalance;
  },
}

const actions = {
  async loadSmsBalance({commit}, businessUid) {
    const smsBalance = await smsService.getSmsBalance(businessUid);
    commit('setSmsBalance', smsBalance);
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
